import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { OrderDetailsResponseBack } from '../../../models';
import { IOrderDetailsHttpService } from '../interfaces';
import { ERROR_ACTION_KEY } from '../../../tokens';

@Injectable()
export class OrderDetailsHttpService implements IOrderDetailsHttpService {
  constructor(protected httpClient: HttpClient) {}

  getOrderDetails(voucherCode: string, country: string): Promise<OrderDetailsResponseBack> {
    return firstValueFrom(
      this.httpClient.get<OrderDetailsResponseBack>(`/order-details/${voucherCode}`, {
        params: { country },
        context: new HttpContext().set(ERROR_ACTION_KEY, 'errors.actions.order_details'),
      }),
    );
  }
}
